
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (from.name !== 'project' && to.name !== 'project') {
    // $('html, body').animate({ scrollTop: 0 }, 900)
    const smoothScroll = (h) => {
      let i = h || window.scrollY + 1
      if (i > 0) {
        setTimeout(() => {
          window.scrollTo(0, i)
          smoothScroll(i - 50)
        }, 10)
      }
    }
    smoothScroll()

    var stripes = document.getElementById('stripes')
    if (stripes.classList.contains('none')) {
      stripes.classList.remove('none')
      setTimeout(function () {
        stripes.classList.add('none')
      }, 2000)
    }
  } else if (from.name === 'project') {
    var project = document.querySelector('#project-' + from.params.id)
    var projectTop = project.offsetTop
    setTimeout(() => { window.scrollTo(0, projectTop) }, 10)
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js